/**
 * Socket.IO server URL for the chat service (via nginx).
 * Webpack dev server often fails to proxy Engine.IO; in dev we connect to nginx directly.
 */
export function getChatSocketUrl() {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const { protocol, hostname, port } = window.location;
  const devNginxPort = '8088';

  if (!port || port === devNginxPort || port === '80' || port === '443') {
    return undefined;
  }

  return `${protocol}//${hostname}:${devNginxPort}`;
}

export const CHAT_SOCKET_PATH = '/socket.io';
